import { ContentType, SectionType } from 'src/types/publishedAssets';

/**
 * What makes a section the hero.
 *
 * One definition, because the answer decides three different things that must agree: which tab is
 * excluded from the tab bar, which group renders without a wrapper so the sticky tab bar keeps its
 * travel, and which navigation mode the page runs in. Answering it separately in each place is how
 * they drift apart.
 */
const HERO_CONTENT_TYPE = 'hero';

/** Whether this section holds the hero. */
export const isHeroSection = (section: SectionType): boolean =>
  section.section_entities.some((entity) => entity.content_type === HERO_CONTENT_TYPE);

/** Whether any section in a group holds the hero. */
export const hasHeroSection = (sections: SectionType[]): boolean => sections.some(isHeroSection);

/**
 * The hero entity itself, for callers that read its metadata rather than only its presence —
 * `section_navigation` and `in_page_tab_navigation` both live on it.
 */
export const findHeroEntity = (sections: SectionType[]): ContentType | undefined =>
  sections.flatMap((section) => section.section_entities).find((entity) => entity.content_type === HERO_CONTENT_TYPE);
